import backend, {LOOM_API} from 'utils/backend/loom/api_library';

import queryString from 'query-string';

import {
  adaptLoomClientDetail,
  adaptLoomClientList,
  toLoomClientListQuery,
} from './client_adapter';

const loomApi = () => {
  if (!LOOM_API) {
    throw new Error('REACT_APP_LOOM_API must be configured before Loom client reads can be enabled.');
  }

  return LOOM_API.replace(/\/$/, '');
};

const queryClient = async (filters, sort, lastEvaluatedKey) => {
  const query = queryString.stringify(
      toLoomClientListQuery(filters, sort, lastEvaluatedKey),
      {skipNull: true, skipEmptyString: true},
  );
  const response = await backend.get(`${loomApi()}/api/careos/clients?${query}`);
  return adaptLoomClientList(response);
};

const getClient = async (clientRn) => {
  const response = await backend.get(`${loomApi()}/api/careos/clients/${encodeURIComponent(clientRn)}`);
  return adaptLoomClientDetail(response);
};

export default {
  getClient,
  queryClient,
};
